export default __webpack_public_path__ + "static/media/sbo-white.87f017fd.svg";